const DURATIONS = { slow: 600, fast: 200 };

const resolveDuration = (duration) => {
  if (typeof duration === 'number') return duration;

  return DURATIONS[duration] ?? 400;
};

const transitionOpacity = (element, opacity, milliseconds) => new Promise((resolve) => {
  element.style.transition = `opacity ${milliseconds}ms`;
  element.style.opacity = opacity;
  setTimeout(resolve, milliseconds);
});

export const fadeOut = (element, duration = 400) => {
  if (!element) return Promise.resolve();

  return transitionOpacity(element, '0', resolveDuration(duration)).then(() => {
    element.style.display = 'none';
  });
};

export const fadeIn = (element, duration = 400) => {
  if (!element) return Promise.resolve();

  element.style.opacity = '0';
  element.style.display = '';
  return transitionOpacity(element, '1', resolveDuration(duration)).then(() => {
    element.style.transition = '';
  });
};
